import React from "react";

export const NAV_ICONS = {
  dashboard: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="3" y="3" width="7" height="9" rx="1.5"/>
      <rect x="14" y="3" width="7" height="5" rx="1.5"/>
      <rect x="14" y="12" width="7" height="9" rx="1.5"/>
      <rect x="3" y="16" width="7" height="5" rx="1.5"/>
    </svg>
  ),
  fact_check: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="3" y="4" width="18" height="17" rx="2.5"/>
      <path d="M9 2.5h6v3H9zM7 11.5l1.8 1.8L12.5 9.6M15 16.5h3"/>
    </svg>
  ),
  assignment: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="3" y="4" width="18" height="17" rx="2.5"/>
      <path d="M9 2.5h6v3H9zM7.5 11h9M7.5 15.5h6"/>
    </svg>
  ),
  calendar_month: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="3" y="5" width="18" height="16" rx="2.5"/>
      <path d="M3 10h18M8 3v4M16 3v4"/>
    </svg>
  ),
  summarize: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="4" y="3" width="16" height="18" rx="2.5"/>
      <path d="M8 8h8M8 12h8M8 16h5"/>
    </svg>
  ),
  access_time: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="12" r="8.5"/>
      <path d="M12 8v4.2l3 1.8"/>
    </svg>
  ),
  settings: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.7 1.7 0 00.3 1.9l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-2.9 1.2V21a2 2 0 11-4 0v-.1A1.7 1.7 0 006 19.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1A1.7 1.7 0 003 13.6H3a2 2 0 110-4h.1A1.7 1.7 0 004.7 6L4.6 6a2 2 0 112.8-2.8l.1.1A1.7 1.7 0 0010.4 3V3a2 2 0 114 0v.1a1.7 1.7 0 002.9 1.2l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00.3 1.9"/>
    </svg>
  ),
  people: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="9" cy="7" r="3.5"/>
      <path d="M2 20v-1a5 5 0 0110 0v1"/>
      <circle cx="17" cy="9" r="2.5"/>
      <path d="M22 20v-1a4 4 0 00-5-3.9"/>
    </svg>
  ),
  group: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="9" cy="7" r="3.5"/>
      <path d="M2 20v-1a5 5 0 0110 0v1"/>
      <circle cx="17" cy="9" r="2.5"/>
      <path d="M22 20v-1a4 4 0 00-5-3.9"/>
    </svg>
  ),
  person: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="8" r="4"/>
      <path d="M4 21v-1a6 6 0 0112 0v1"/>
    </svg>
  ),
  badge: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="3" y="6" width="18" height="14" rx="2.5"/>
      <circle cx="12" cy="12" r="2.5"/>
      <path d="M8 3h8v4H8z"/>
    </svg>
  ),
  event_available: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="3" y="5" width="18" height="16" rx="2.5"/>
      <path d="M3 10h18M8 3v4M16 3v4M9 15l2 2 4-4"/>
    </svg>
  ),
  description: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="4" y="3" width="16" height="18" rx="2.5"/>
      <path d="M8 8h8M8 12h8M8 16h5"/>
    </svg>
  ),
  desktop_windows: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="2" y="4" width="20" height="13" rx="2"/>
      <path d="M8 21h8M12 17v4"/>
    </svg>
  ),
  monitor_heart: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="2" y="4" width="20" height="13" rx="2"/>
      <path d="M7 11h2l2-3 2 6 2-3h2"/>
    </svg>
  ),
  schedule: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="12" r="8.5"/>
      <path d="M12 8v4.2l3 1.8"/>
    </svg>
  ),
  business: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="4" y="4" width="16" height="17" rx="2"/>
      <path d="M9 21V8M15 21V8M4 8h16"/>
    </svg>
  ),
  admin_panel_settings: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M12 2l8 4v5c0 5.5-3.4 10.7-8 12-4.6-1.3-8-6.5-8-12V6l8-4z"/>
      <circle cx="12" cy="10" r="2"/>
      <path d="M12 14v2"/>
    </svg>
  ),
  work_outline: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="2" y="7" width="20" height="14" rx="2.5"/>
      <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
    </svg>
  ),
  beach_access: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="13.5" cy="6.5" r="4"/>
      <path d="M17.5 10.5L22 15M2 22l14-14"/>
    </svg>
  ),
  trending_up: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
      <polyline points="17 6 23 6 23 12"/>
    </svg>
  ),
  timer: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="13" r="8"/>
      <path d="M12 9v4l2.5 1.5M10 2h4"/>
    </svg>
  ),
  event: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="3" y="5" width="18" height="16" rx="2.5"/>
      <path d="M3 10h18M8 3v4M16 3v4"/>
      <circle cx="12" cy="15" r="1.5"/>
    </svg>
  ),
};
